<div class="grid-x">
  <div class="cell large-12 medium-12 small-12 bold">
    <div class="section-header" [ngClass]="{ 'active' : step == activeStep }" (click)="toggleOpen()">
      <span class="margin-right">Step 2: Permit Type</span>
      <button class="icon-button">
        @if (isOpen == false) {
          <svg-icon icon="icon-caret-right"></svg-icon>
        }
        @if (isOpen == true) {
          <svg-icon icon="icon-caret-down"></svg-icon>
        }
      </button>
    </div>
  </div>
</div>
<div class="grid-x margin-top" [formGroup]="form" [ngClass]="{ 'hideSection': isOpen == false }">
  <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
    Type of Permit<span [ngClass]="{ 'red': form?.get('type')?.invalid }">*</span>:
    @if (fieldHasNotes('permitType|type') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'permitType|type'" [notes]="getFilteredNotes('permitType|type')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-9 medium-9 small-6">
    @for (opt of permitOptions; track opt) {
      <span class="padding-right"><input type="radio" formControlName="type" (ngModelChange)="permitTypeChanged($event)" [value]="opt.id" /> {{opt.text}}</span>
    }
  </div>
  <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
    Previously Issued API #<span [ngClass]="{ 'red': apiInvalid }">*</span>:
    @if (fieldHasNotes('permitType|existingAPI') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'permitType|existingAPI'" [notes]="getFilteredNotes('permitType|existingAPI')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-9 medium-9 small-6">
    <input type="text" formControlName="existingAPI" />
  </div>
  <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
    Expedite Application?<span [ngClass]="{ 'red': form?.get('expedite')?.invalid }">*</span>:
    @if (fieldHasNotes('permitType|expedite') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'permitType|expedite'" [notes]="getFilteredNotes('permitType|expedite')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-9 medium-9 small-6">
    <span class="padding-right"><input type="radio" formControlName="expedite" [value]="false" /> No</span>
    <span class="padding-right"><input type="radio" formControlName="expedite" [value]="true" /> Yes</span>
    @if (showFeeSimple) {
      <span class="red italic">
        *Landowner Fee Simple Ownership Affidavit is required when expediting in a coal-bearing township.
      </span>
    }
  </div>
  @if (expeditSetting?.isActive) {
    <div class="cell large-12 medium-12 small-12 red italic text-align-center" [innerHTML]="expediteMessage">
    </div>
  } @else {
    <div class="cell large-12 medium-12 small-12 red italic text-align-center" [innerHTML]="noExpediteMessage">
    </div>
  }
  <div class="cell large-3 medium-3 small-3 bold padding-right text-align-right">
    Well Orientation<span [ngClass]="{ 'red': form?.get('orientation')?.invalid }">*</span>:
    @if (fieldHasNotes('permitType|orientation') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'permitType|orientation'" [notes]="getFilteredNotes('permitType|orientation')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-9 medium-9 small-6">
    @for (opt of orientationOptions; track opt) {
      <span class="padding-right"><input type="radio" formControlName="orientation" (ngModelChange)="orientationChanged($event)" [value]="opt.id" /> {{opt.text}}</span>
    }
  </div>
</div>

